import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-daisyui';
import Modal from '@/components/modals/Modal/Modal.tsx';
import { useTripContext } from '@/context/TripContext.tsx';
import { pillClassName } from '@/components/shared/tripControlClassNames.ts';

const CodyReplyModal: FC = () => {
  const { t } = useTranslation();
  const { codyReply, dismissCodyReply, answerCodyQuestion, isLoadingAction } = useTripContext();

  if (!codyReply) return null;

  const isQuestion = codyReply.kind === 'question';

  return (
    <Modal.Wrapper wrapperClassName="w-[440px]" isOpen onClose={dismissCodyReply} showCloseButton={false} closeable>
      <Modal.Title>
        <h2 className="text-balance text-center font-feature text-2xl font-bold italic">
          {isQuestion ? codyReply.question.text : t('tripPage.cody.reply_title')}
        </h2>
      </Modal.Title>

      {isQuestion ? (
        <div className="flex flex-col gap-5">
          <p className="text-pretty text-center text-sm text-text-secondary">
            {t('tripPage.changes.you_asked', { ask: codyReply.ask })}
          </p>
          <div className="flex flex-wrap justify-center gap-2">
            {codyReply.question.options.map((option) => (
              <button
                key={option.label}
                type="button"
                className={pillClassName}
                disabled={isLoadingAction}
                onClick={() => answerCodyQuestion(option)}
              >
                {option.label}
              </button>
            ))}
          </div>
        </div>
      ) : (
        <p className="text-pretty text-center text-base leading-relaxed text-[#2F2D2A]">{codyReply.message}</p>
      )}

      <Modal.Nav>
        {({ handleClose }) => (
          <Button type="button" color="ghost" className="w-full text-primary" onClick={handleClose}>
            {t('tripPage.cody.close')}
          </Button>
        )}
      </Modal.Nav>
    </Modal.Wrapper>
  );
};

export default CodyReplyModal;
